import { getExportTaskDetail, getExportTaskDownloadUrl } from '@/api/exportApi'

const SUCCESS_STATUS = new Set(['success'])
const FAILED_STATUS = new Set(['failed'])
const PENDING_STATUS = new Set(['pending', 'processing'])

function extractDownloadUrl(data) {
  if (!data) return null
  if (typeof data === 'string') return data
  return data.download_url || data.url || data.presigned_url || null
}

function extractFileName(data) {
  if (!data || typeof data !== 'object') return undefined
  return data.file_name || data.filename || data.name
}

/** 轮询导出任务，success 时 resolve 任务详情 */
export function pollExportTask(taskNo, { intervalMs = 2000, timeoutMs = 300000 } = {}) {
  const started = Date.now()

  return new Promise((resolve, reject) => {
    const poll = async () => {
      if (Date.now() - started > timeoutMs) {
        reject(new Error('导出超时，请稍后重试'))
        return
      }
      try {
        const res = await getExportTaskDetail(taskNo)
        const data = res.data || {}
        const status = String(data.status || '').toLowerCase()

        if (SUCCESS_STATUS.has(status)) {
          resolve(data)
          return
        }
        if (FAILED_STATUS.has(status)) {
          reject(new Error(data.error_message || data.errmsg || '导出失败'))
          return
        }
        if (PENDING_STATUS.has(status) || !status) {
          setTimeout(poll, intervalMs)
          return
        }
        setTimeout(poll, intervalMs)
      } catch (err) {
        reject(err)
      }
    }
    poll()
  })
}

/** 请求下载地址并触发浏览器下载 */
export async function downloadExportTaskFile(taskNo) {
  const res = await getExportTaskDownloadUrl(taskNo)
  const downloadUrl = extractDownloadUrl(res.data)
  if (!downloadUrl) {
    throw new Error('缺少下载地址')
  }
  triggerFileDownload(downloadUrl, extractFileName(res.data))
}

/** 将接口返回的 download_url 转为可访问地址并触发下载 */
export function triggerFileDownload(downloadUrl, fileName) {
  if (!downloadUrl) {
    throw new Error('缺少下载地址')
  }

  let href = downloadUrl
  if (href.startsWith('/nextpharma/device/api/')) {
    href = href.replace('/nextpharma/device/api', '/api')
  } else if (href.startsWith('/v1/')) {
    href = `/api${href}`
  }

  const link = document.createElement('a')
  link.href = href
  link.target = '_blank'
  link.rel = 'noopener noreferrer'
  if (fileName) {
    link.download = fileName
  }
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
